import request from '@/utils/http';
import { SRM } from '../constant/constant.js';

// 股东信息-查询列表
export const getTableData = (params) => {
    return request({
        url: `${SRM}/supplierStockholderInfos`,
        method: 'post',
        data: params
    });
};
// 股东信息-同步
export const synShareholderInfo = (params) => {
    return request({
        url: `${SRM}/synShareholderInfo`,
        method: 'post',
        data: params
    });
};
// 股东信息-保存
export const saveShareholderInfo = (params) => {
    return request({
        url: `${SRM}/preserveStockholderInfoFile`,
        method: 'post',
        data: params
    });
};
// 股东信息-保存单个附件
export const saveAttachmentInfo = (params) => {
    return request({
        url: `${SRM}/preserveFile`,
        method: 'post',
        data: params
    });
};

// 股东信息-新增
export const addShareholder = data => {
    return request({
        url: `${SRM}/supplierStockholderInfo/add`,
        method: 'post',
        data
    });
};

// 股东信息-编辑
export const editShareholder = data => {
    return request({
        url: `${SRM}/supplierStockholderInfo/edit`,
        method: 'post',
        data
    });
};

// 股东信息-删除
export const deleteShareholder = data => {
    return request({
        url: `${SRM}/supplierStockholderInfo/delete`,
        method: 'post',
        data
    });
};
